module.exports = __webpack_public_path__ + "img/1-2-p3.c28622a4.svg";